// ===== Referenced Resources =====
// https://andrebnassis.medium.com/setting-eslint-on-a-react-typescript-project-2021-1190a43ffba

// ===== Packages =====

import React                    from 'react';
import ReactDOM                 from 'react-dom';
import styled, { ThemeContext } from 'styled-components';
import { BrowserRouter }        from 'react-router-dom';
import { DndProvider }          from 'react-dnd';
import { HTML5Backend }         from 'react-dnd-html5-backend';
import { TouchBackend }         from 'react-dnd-touch-backend';

// ===== Firebase =====

import fire                     from './fire';

// ===== Components =====

import App                      from './App';
import Spinner                  from './images/editor/spinner.svg';

// ===== Services =====

import {
    detectTouchDevice,
}                               from './services';

// ===== Constants =====

import {
    BODY_FONT_SIZE,
}                               from './constants/generalConstants';

// ===== Stylesheets =====

import { theme }                from './themes/theme-context';
import { GlobalStyle }          from './styles/global';

const RedirectPlaceholderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background-color: ${theme.verascopeColor.purple200};
`;
const SpinnerContainer = styled.img`
    width: ${`${2 * BODY_FONT_SIZE}px`};
    height: ${`${2 * BODY_FONT_SIZE}px`};
    animation: rotate 2s linear infinite;
    margin: 0;
`;

function Root(): JSX.Element {
    const { redirectReady } = fire(); // same singleton promise
    const [ready, setReady] = React.useState(false);

    React.useEffect(() => {
        let mounted = true;
        redirectReady?.finally(() => { if (mounted) setReady(true); });
        return () => { mounted = false; };
    }, [redirectReady]);

    return (
        <React.StrictMode>
            <ThemeContext.Provider value={theme}>
                <DndProvider backend={detectTouchDevice(document) ? TouchBackend : HTML5Backend}>
                    <GlobalStyle />
                    <BrowserRouter>
                        {ready
                            ? (<App />)
                            : (
                                <RedirectPlaceholderContainer>
                                    <SpinnerContainer
                                        src={Spinner}
                                        alt="spinner"
                                    />
                                </RedirectPlaceholderContainer>
                            )}
                    </BrowserRouter>
                </DndProvider>
            </ThemeContext.Provider>
        </React.StrictMode>
    );
}

ReactDOM.render(<Root />, document.getElementById('root'));
